import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import GoogleMapReact from 'google-map-react';
import '../driverLive/liveDriver.css';

const DEFAULT_CENTER = { lat: 26.9041268, lng: 75.7846981 };
const MAP_API_KEY = 'AIzaSyB0odnoi2ib7N0eNxE2GWwf9xe_aC87PZI';
const DEFAULT_ZOOM = 14;

// ---- START of additional code from the Node.js logic ----
const MAX_SNAP_DISTANCE = 0.001;

const calculateDistance = (p1, p2) => {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
};

const generatePath = (vtsPath, fixedPath) => {
    if (
        !vtsPath ||
        !fixedPath ||
        vtsPath.length === 0 ||
        fixedPath.length === 0
    ) {
        console.error("Invalid input: vtsPath or fixedPath is empty or null.");
        return [];
    }

    const snappedVtsPoints = [];

    for (const vtsPoint of vtsPath) {
        let minDistance = Infinity;
        let nearestFixedPoint = null;

        for (const fixedPoint of fixedPath) {
            const distance = calculateDistance(vtsPoint, fixedPoint);
            if (distance < minDistance) {
                minDistance = distance;
                nearestFixedPoint = fixedPoint;
            }
        }

        if (nearestFixedPoint && minDistance < MAX_SNAP_DISTANCE) {
            snappedVtsPoints.push(nearestFixedPoint);
        } else {
            snappedVtsPoints.push(vtsPoint);
        }
    }

    const finalPathPoints = [];

    if (snappedVtsPoints.length > 0) {
        finalPathPoints.push(snappedVtsPoints[0]);

        for (let i = 1; i < snappedVtsPoints.length; i++) {
            const prevSnappedPoint = snappedVtsPoints[i - 1];
            const currentSnappedPoint = snappedVtsPoints[i];

            const prevFixedIndex = fixedPath.findIndex(
                (p) => p.x === prevSnappedPoint.x && p.y === prevSnappedPoint.y
            );
            const currFixedIndex = fixedPath.findIndex(
                (p) => p.x === currentSnappedPoint.x && p.y === currentSnappedPoint.y
            );

            if (prevFixedIndex !== -1 && currFixedIndex !== -1) {
                if (currFixedIndex > prevFixedIndex) {
                    for (let k = prevFixedIndex + 1; k <= currFixedIndex; k++) {
                        finalPathPoints.push(fixedPath[k]);
                    }
                } else {
                    finalPathPoints.push(currentSnappedPoint);
                }
            } else {
                finalPathPoints.push(currentSnappedPoint);
            }
        }
    }

    return finalPathPoints;
};
// ---- END of additional code from the Node.js logic ----


const CollectionRoute = ({ id, collection_date, boundry, geoId, start_location, end_location }) => {
    const [mapInstance, setMapInstance] = useState(null);
    const [googleMaps, setGoogleMaps] = useState(null);
    const [tripLocationDataPath, setTripLocationDataPath] = useState([]);
    const [tooltipData, setTooltipData] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState(null);
    const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
    const [segregation, setSegregation] = useState([])
    const [geoPath, setGeoPath] = useState([]);
    const [fixPath, setFixpath] = useState([]);
    const [vtsPath, setVtsPath] = useState([]);
    const [activePaths, setActivePaths] = useState(['a', 'b', 'c']);
    const [generatedPath, setGeneratedPath] = useState([]); // New state for generated path
    const { id: assignment_id } = useParams();


    // console.log("vtsPath", vtsPath);


    // geoPath
    useEffect(() => {
        const fetchData = async (geoId) => {
            try {
                const response = await fetch(`https://apis.ecowrap.in/b2g/eco-admin/geo-fence?geo_id=${geoId}`, {
                    headers: {
                        authorization: `Bearer ${(localStorage.getItem("tokenAdminPanel"))}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response?.json();
                setGeoPath(result?.data);
                // console.log("result?.data", result?.data);

            } catch (error) {
                console.log('error', error);
            }
        };
        fetchData(geoId);
    }, [geoId]);

    useEffect(() => {
        const polygons = [];
        const polylines = [];

        if (mapInstance && googleMaps) {
            const polylineCoordinates = geoPath[0]?.boundry[0]?.map((cord) => ({
                lat: cord?.x,
                lng: cord?.y,
            }));

            const polyline = new googleMaps.Polyline({
                path: polylineCoordinates,
                strokeColor: '#808080',
                strokeOpacity: 2,
                strokeWeight: 5.5,
            });

            polyline.setMap(mapInstance);
            polylines.push(polyline);
        }

        // Cleanup function to remove polygons and polylines
        return () => {
            polygons.forEach((polygon) => {
                polygon.setMap(null);
            });

            polylines.forEach((polyline) => {
                polyline.setMap(null);
            });
        };
    }, [geoPath, mapInstance, googleMaps]);


    // fix path
    useEffect(() => {
        const fetchData = async (geoId) => {
            try {
                const response = await fetch(`https://apis.ecowrap.in/b2g/eco-admin/fix-path?geo_id=${geoId}`, {
                    headers: {
                        authorization: `Bearer ${(localStorage.getItem("tokenAdminPanel"))}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response?.json();
                setFixpath(result?.data)
            } catch (error) {
                console.log('error', error);
            }
        };
        fetchData(geoId);
    }, [geoId]);

    useEffect(() => {
        const polygons = [];
        const polylines = [];

        if (mapInstance && googleMaps) {
            const polylineCoordinates = fixPath.map((cord) => ({
                lat: cord?.x,
                lng: cord?.y,
            }));

            const polyline = new googleMaps.Polyline({
                path: polylineCoordinates,
                strokeColor: 'red',
                strokeOpacity: 1.0,
                strokeWeight: 2,
            });

            polyline.setMap(mapInstance);
            polylines.push(polyline);
        }

        // Cleanup function to remove polygons and polylines
        return () => {
            polygons.forEach((polygon) => {
                polygon.setMap(null);
            });

            polylines.forEach((polyline) => {
                polyline.setMap(null);
            });
        };
    }, [fixPath, mapInstance, googleMaps]);


    // App Path
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://apis.ecowrap.in/b2g/eco-admin/travelled-path-app/?assignment_id=${assignment_id}`, {
                    headers: {
                        authorization: `Bearer ${(localStorage.getItem("tokenAdminPanel"))}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response?.json();
                setTripLocationDataPath(result?.data);
            } catch (error) {
                console.log('error', error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const polygons = [];
        const polylines = [];

        if (!activePaths.includes('a')) {
            return
        }

        if (mapInstance && googleMaps) {
            const polylineCoordinates = tripLocationDataPath.map((cord) => ({
                lat: cord?.location?.x,
                lng: cord?.location?.y,
            }));


            const polyline = new googleMaps.Polyline({
                path: polylineCoordinates,
                strokeColor: '#53AF5C',
                strokeOpacity: 1.5,
                strokeWeight: 4,
            });

            polyline.setMap(mapInstance);
            polylines.push(polyline);
        }

        // Cleanup function to remove polygons and polylines
        return () => {
            polygons.forEach((polygon) => {
                polygon.setMap(null);
            });

            polylines.forEach((polyline) => {
                polyline.setMap(null);
            });
        };
    }, [tripLocationDataPath, mapInstance, googleMaps, activePaths]);

    // segregation
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://apis.ecowrap.in/b2g/eco-admin/segregation-path/${assignment_id}`, {
                    headers: {
                        authorization: `Bearer ${(localStorage.getItem("tokenAdminPanel"))}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response?.json();
                setSegregation(result?.data)
                // console.log("result?.data", result?.data);

            } catch (error) {
                console.log('error', error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const markers = [];  // To store the created markers for cleanup
        let polyline = null; // To store the polyline for cleanup

        if (!activePaths.includes('b')) {
            return;
        }

        if (mapInstance && googleMaps) {
            // Prepare coordinates for polyline
            const polylineCoordinates = [];

            segregation.forEach((cord) => {
                const latLng = {
                    lat: cord?.location?.x,
                    lng: cord?.location?.y,
                };

                // Create a new dot marker for each (x, y) coordinate
                const marker = new googleMaps.Marker({
                    position: latLng,
                    map: mapInstance,
                    title: `Point (${cord?.location?.x}, ${cord?.location?.y})`,
                    icon: {
                        path: googleMaps.SymbolPath.CIRCLE,
                        scale: 5,
                        strokeColor: 'blue',
                        strokeWeight: 2,
                        fillColor: 'blue',
                        fillOpacity: 1,
                    },
                });

                markers.push(marker);
                polylineCoordinates.push(latLng);

                const infoWindow = new googleMaps.InfoWindow({
                    content: `<div><strong> <p> <span> ${cord?.location?.x}, ${cord?.location?.y} </span>  <span> House Number = ${cord?.house_number} </span> </p>
                    <p>  <span> Segregate = ${cord?.is_segregate == 1 ? "Yes" : 'No'} </span>  <span> remark = ${cord?.remark}  </span> </p> <p> <span> waste Category = ${JSON.parse(cord?.waste_category)} </span> <span> Waste Provided = ${cord?.waste_provided == 1 ? "Yes" : 'No'} </span> </p> </strong></div>`,
                });

                marker.addListener('mouseover', () => {
                    infoWindow.open(mapInstance, marker);
                });

                marker.addListener('mouseout', () => {
                    infoWindow.close();
                });
            });

            if (polylineCoordinates.length > 1) {
                polyline = new googleMaps.Polyline({
                    path: polylineCoordinates,
                    strokeColor: 'blue',
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                });

                polyline.setMap(mapInstance);
            }
        }

        // Cleanup function to remove markers and polyline
        return () => {
            markers.forEach((marker) => {
                marker.setMap(null);
            });

            if (polyline) {
                polyline.setMap(null);
            }
        };
    }, [segregation, mapInstance, googleMaps, activePaths]);



    // vts path
    useEffect(() => {
        const fetchData = async (geoId) => {
            try {
                const response = await fetch(`https://apis.ecowrap.in/b2g/eco-admin/travelled-path-vts/?assignment_id=${assignment_id}`, {
                    headers: {
                        authorization: `Bearer ${(localStorage.getItem("tokenAdminPanel"))}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response?.json();
                setVtsPath(result?.data)
                // setGeoPath(result?.data);
            } catch (error) {
                console.log('error', error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const polygons = [];
        const polylines = [];
        if (!activePaths.includes('c')) {
            return
        }

        if (mapInstance && googleMaps) {
            const polylineCoordinates = vtsPath?.map((cord) => ({
                lat: cord?.location?.x,
                lng: cord?.location?.y,
            }));

            const polyline = new googleMaps.Polyline({
                path: polylineCoordinates,
                strokeColor: 'brown',
                strokeOpacity: 2,
                strokeWeight: 5.5,
            });

            polyline.setMap(mapInstance);
            polylines.push(polyline);
        }

        // Cleanup function to remove polygons and polylines
        return () => {
            polygons.forEach((polygon) => {
                polygon.setMap(null);
            });

            polylines.forEach((polyline) => {
                polyline.setMap(null);
            });
        };
    }, [vtsPath, mapInstance, googleMaps, activePaths]);

    // ---- START of new code for generated path ----
    useEffect(() => {
        if (vtsPath.length > 0 && fixPath.length > 0) {
            // Reformat vtsPath to match the {x, y} structure of fixPath
            const formattedVtsPath = vtsPath.map(p => ({ x: p.location.x, y: p.location.y }));
            const newGeneratedPath = generatePath(formattedVtsPath, fixPath);
            setGeneratedPath(newGeneratedPath);
        }
    }, [vtsPath, fixPath]);

    useEffect(() => {
        const polygons = [];
        const polylines = [];

        if (!activePaths.includes('d')) {
            return;
        }

        if (mapInstance && googleMaps) {
            const polylineCoordinates = generatedPath.map((cord) => ({
                lat: cord.x,
                lng: cord.y,
            }));

            const polyline = new googleMaps.Polyline({
                path: polylineCoordinates,
                strokeColor: 'purple',
                strokeOpacity: 2,
                strokeWeight: 5.5,
            });

            polyline.setMap(mapInstance);
            polylines.push(polyline);
        }

        return () => {
            polylines.forEach((polyline) => {
                polyline.setMap(null);
            });
        };
    }, [generatedPath, mapInstance, googleMaps, activePaths]);
    // ---- END of new code for generated path ----

    // Remove from map
    const pathhandle = (e) => {
        if (e === "a") {
            setActivePaths(['a']);
        } else if (e === "b") {
            setActivePaths(['b']);
        } else if (e === "c") {
            setActivePaths(['c']);
        } else if (e === "d") { // New case for generated path
            setActivePaths(['d']);
        }
    }
    return (
        <div className="container-fluid map_box">
            <div className="row">
                <div className='d-flex z-4'>
                    <div className="col-md-12 w-75 d-flex justify-content-between align-items-center">
                        <h3 className='heading_CollectionBox'>Live Location Map</h3>
                    </div>
                </div>

                {/* <div className='d-flex gap-2'>
                    <p className='text-danger'>Fix Path </p>
                    <p className='text-secondary'>Boundary</p>
                    <p className='text-success'>App Path</p>
                    <p className='text-primary'>Segregation Path</p>
                    <p style={{ color: "brown" }}>Vts Path</p>
                    <p style={{ color: "purple" }}>Generated Path</p>
                </div> */}

                <div className="col-md-12" style={{ height: '67vh', width: '100%', position: 'relative' }}>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: MAP_API_KEY }}
                        defaultCenter={DEFAULT_CENTER}
                        defaultZoom={1}
                        yesIWantToUseGoogleMapApiInternals
                        center={DEFAULT_CENTER}
                        zoom={DEFAULT_ZOOM}
                        onGoogleApiLoaded={({ map, maps }) => {
                            setMapInstance(map);
                            setGoogleMaps(maps);
                        }}
                    >
                        {/* <section className="driverLive_box map_pathbox">
                            <div className="radio-list">
                                <div className="driverLive_list">
                                    <input name="radio" onClick={() => pathhandle("a")} id="offlineTripPathData" type="radio" />
                                    <label htmlFor="offlineTripPathData" style={{ color: "green" }}>App Path</label>
                                </div>
                                <div className="driverLive_list">
                                    <input name="radio" onClick={() => pathhandle("b")} id="tripLocationData" type="radio" />
                                    <label htmlFor="tripLocationData" style={{ color: "blue" }}>Segregation Path</label>
                                </div>
                                <div className="driverLive_list">
                                    <input name="radio" onClick={() => pathhandle("c")} id="vtsPathData" type="radio" />
                                    <label htmlFor="vtsPathData" style={{ color: "brown" }}>VtsPath</label>
                                </div>
                                <div className="driverLive_list">
                                    <input name="radio" onClick={() => pathhandle("d")} id="generatedPath" type="radio" />
                                    <label htmlFor="generatedPath" style={{ color: "purple" }}>Full vts Path</label>
                                </div>
                            </div>
                        </section> */}
                    </GoogleMapReact>

                    {tooltipData && tooltipPosition && (
                        <>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: `${cursorPos?.y - 150}px`,
                                    left: `${cursorPos?.x}px`,
                                    backgroundColor: 'white',
                                    padding: '2vw',
                                    border: '1px solid black',
                                    borderRadius: '5px',
                                    transform: 'translate(-50%, -100%)',
                                    zIndex: 1000,
                                }}
                            >
                                {tooltipData}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div >
    );

};

export default CollectionRoute;